import {useMemo} from 'react';
import type {CodeList} from 'services/codelists/types';
import type {CodelistRestrictor} from 'services/codelists';

/**
 * Creates stable restrictor references
 */
export const useMemoizedCodelistRestrictor = (
  restrict: CodelistRestrictor,
): CodelistRestrictor =>
  useMemo(() => {
    const cache = new WeakMap<CodeList, CodeList>();

    return (codelist: CodeList) => {
      const cached = cache.get(codelist);
      if (cached) {
        return cached;
      }

      const restricted = restrict(codelist);
      cache.set(codelist, restricted);
      return restricted;
    };
  }, [restrict]);
